import React, { useEffect, useState } from "react";
import { Loader } from "../../loader";
import { useForm } from "react-hook-form";
import { fetchAPI } from "../../service/Encrtyption";
import { useTranslation } from "react-i18next";
import { useParamarshDetails } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate, useParams } from "react-router-dom";
import { rewardMoney } from "../../auth/redux/store";
import ReactGA from 'react-ga4';
import Header from "../../layout/Header";
import CustomModal from "../../modal";
export const BankDetails = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    clearErrors,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [ifsc, setIfsc] = useState();
  const user = useSelector((state) => state.user);
  const mobileNumber = user?.mobileNumber;
  const [errorMessage, setErrorMessage] = useState("");
  const claimValue = useSelector((state) => state.claimValue);
  const [fetchData, rewardsData, reclaimRewards, reclaimData, cashRewardsData, loader] = useParamarshDetails();
  const amount = useSelector((state) => state.amount);
  const reclaimDataObj = useSelector((state) => state.reclaimDataObj);
  const [responseModal, setResponseModal] = useState({
    show: false,
    message: "",
    status: "",
  });
  console.log(amount + "amount");

  console.log(claimValue + "claimValue");



  const [formData, setFormData] = useState({
    accountName: "",
    accountNumber: "",
    cashFreeTransactionId: 0,
    cashRewards: "",
    claimIDs: [],
    dsrProgramId: 0,
    ecouponFarmerMapId: 0,
    ifscCode: "",
    paymentMode: "banktransfer",
    phoneNumber: mobileNumber,
    seadProgramId: 0,
    destinationURL: "/cashFreeReward/cashFreePaymentModeRequest_V2",
  });

  useEffect(() => {
    if (!claimValue) {
      // If claimValue is falsy (null, undefined, false, etc.), update formData
      setFormData((prevData) => ({
        ...prevData,
        cashFreeTransactionId: reclaimDataObj.cashFreeTransactionId,
        cashRewards: reclaimDataObj.amount,
        claimIDs: [],
      }));
    } else {
      // If claimValue is truthy, fetch data (assuming fetchData is defined)
      fetchData();
    }
  }, [claimValue, reclaimDataObj, setFormData]);

  const handleChange = (fieldName, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
      cashRewards: claimValue ? cashRewardsData : amount,
      claimIDs: claimValue ? rewardsData : []
    }));
    clearErrors(fieldName);
  };


  const onSubmit = async () => {

    console.log(formData, "formData from Bank details");

    ReactGA.event({
      category: 'User Bank Details',
      label: 'Bank Details Form Submit',
      action: 'Claim Bank Details Clicked'
    });

    if (!formData.cashRewards || !formData.accountName || (formData.claimIDs && formData.claimIDs.length == 0)) {
      setErrorMessage(t("sessionExpired"));
      setTimeout(() => {
        navigate(`/${lang}/home`);
      }, 2000);
      return;
    }

    setLoading(true);
    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          mobileNumber: mobileNumber,
          appLangCode: lang
        }
      );
      //  debugger;
      const jsonReposneData = JSON.parse(responseData);
      console.log(JSON.stringify(jsonReposneData) + "bank claim res data");

      const responseStatus = String(
        jsonReposneData?.status ??
        jsonReposneData?.subCode ??
        jsonReposneData?.statusCode ??
        ""
      );
      if (jsonReposneData?.statusCode === "200" && responseStatus === "200") {
        navigate(`/${lang}/transferSucces`);
      } else {
        setResponseModal({
          show: true,
          message: jsonReposneData?.secondaryMsg || jsonReposneData?.message || "",
          status: responseStatus,
        });
        if (responseStatus === "201") {
          setTimeout(() => navigate(`/${lang}/home`), 2000);
        }
      }

      // if (jsonReposneData?.statusCode === "200" || jsonReposneData?.subCode === "200") {
      //   navigate(`/${lang}/transferSucces`)
      // } else {
      //   setErrorMessage(jsonReposneData.secondaryMsg);
      //   setErrorMessage(jsonReposneData.message);
      // }
    } catch (error) {
      setErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const hide = () => {
    setErrorMessage(""); // Assuming you have a state to manage the error message
  };

  const accountNumber = watch("accountNumber");
  const confirmaccountNumber = watch("confirmaccountNumber");

  const closeResponseModal = () => {
    setResponseModal((prevModal) => ({ ...prevModal, show: false }));
  };

  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          {loader && <Loader />}
          <div className="card border-0">
            <Accordion.Header id="transfer">
              <div>
                <i className="fa fa-chevron-left text-white mr-2" onClick={() => {
                  ReactGA.event({
                    category: 'Back To Home Btn',
                    label: 'Bank Details To Home Btn',
                    action: 'Bank Details to Home Clicked'
                  });
                  navigate(`/${lang}/home`)
                }}></i>
                {t("transfer")}
              </div>
              <span className="float-end">
                <span>₹ {amount}</span>
              </span>
            </Accordion.Header>
            <div className="card-body px-2 pt-0 pb-2">
              <div className="px-4 py-2 mt-3">
                <i className="fa fa-arrow-left mr-2" onClick={() => {
                  ReactGA.event({
                    category: 'Back To Payment Mode Btn',
                    label: 'Bank Details To Payment Mode Btn',
                    action: 'Bank Details to Payment Mode Clicked'
                  });
                  navigate(`/${lang}/paymentmode`)
                }
                }></i>
                <span className="infoText mb-0">{t("bankDetails")}</span>
                <hr className="mt-2" />

                <div className="mt-5">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div>
                      <input
                        type="text"
                        placeholder={t("accountHolderName")}
                        name="accountName"
                        id="accountName"
                        className={`form-control bankInput mb-2 ${errors.accountName ? "is-invalid" : ""
                          }`}
                        {...register("accountName", {
                          required: t("accountHolderNameErrorMsg"),
                        })}
                        onChange={(e) =>
                          handleChange("accountName", e.target.value)
                        }
                      />
                      {errors.accountName && (
                        <div className="invalid-feedback">
                          {errors.accountName.message}
                        </div>
                      )}
                    </div>

                    <div>
                      <input
                        type="number"
                        placeholder={t("accountNumber")}
                        name="accountNumber"
                        id="accountNumber"
                        maxLength={"20"}
                        className={`form-control bankInput mb-2 ${errors.accountNumber ? "is-invalid" : ""
                          }`}
                        {...register("accountNumber", {
                          required: t("accountNumberErrorMsg"),
                          onChange: (e) => handleChange("accountNumber", e.target.value),
                        })}
                      />
                      {errors.accountNumber && (
                        <div className="invalid-feedback">
                          {errors.accountNumber.message}
                        </div>
                      )}
                    </div>

                    <div>
                      <input
                        type="number"
                        placeholder={t("confirmaccountNumber")}
                        name="confirmaccountNumber"
                        id="confirmaccountNumber"
                        maxLength={"20"}
                        className={`form-control bankInput mb-2 ${errors.confirmaccountNumber ? "is-invalid" : ""
                          }`}
                        {...register("confirmaccountNumber", {
                          required: t("confirmaccountNumberErrorMsg"),
                          validate: (value) =>
                            value === accountNumber || t("confirmAccountNumberMismatch"),
                        })}
                      />
                      {errors.confirmaccountNumber && (
                        <div className="invalid-feedback">
                          {typeof errors.confirmaccountNumber.message === "string" ? (
                            errors.confirmaccountNumber.message
                          ) : (
                            <span>Invalid value</span>
                          )}
                        </div>
                      )}
                    </div>

                    <div>
                      <input
                        type="text"
                        placeholder={t("IFSCCode")}
                        name="ifscCode"
                        id="ifscCode"
                        maxLength={11}
                        className={`form-control bankInput mb-2 ${errors.ifscCode ? "is-invalid" : ""
                          }`}
                        {...register("ifscCode", {
                          required: t("IFSCCodeErrorMsg"),
                        })}
                        onChange={(e) =>
                          handleChange("ifscCode", e.target.value)
                        }
                      />
                      {errors.ifscCode && (
                        <div className="invalid-feedback">
                          {errors.ifscCode.message}
                        </div>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary w-100 py-3
                      center-textbtn mt-3 text-white text-uppercase
                      registerSubmitBtn"
                      id="submitBtn"
                    >
                      {t("confirm")}
                    </button>
                  </form>
                </div>

                <CustomModal
                  id={"upiResponseModal"}
                  title={
                    <>
                      <h5 style={{ fontWeight: "800" }}>{t('Alert')}</h5>
                      <hr className="mb-0"></hr>
                    </>
                  }
                  content={
                    <>
                      <p
                        className="mb-0"
                        dangerouslySetInnerHTML={{
                          __html: responseModal.message
                            ?.toLowerCase()
                            .replace(/\b\w/g, (char) => char.toUpperCase()),
                        }}
                      />
                    </>}
                  footer={
                    responseModal.status === "422" ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100 py-2"
                        onClick={closeResponseModal}
                      >
                        {t('modify')}
                      </button>
                    ) : responseModal.status === "423" ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100 py-2"
                        onClick={() => {
                          closeResponseModal();
                          navigate(`/${lang}/home`);
                        }}
                      >
                        {t('close')}
                      </button>
                    ) : responseModal.status !== "201" ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100 py-2"
                        onClick={closeResponseModal}
                      >
                        {t('close')}
                      </button>
                    ) : null
                  }
                  show={responseModal.show}
                  onHide={closeResponseModal}
                />

                {errorMessage && (
                  <div
                    className="alert alert-warning alert-dismissible fade show mt-2"
                    role="alert"
                  >
                    {errorMessage}
                    <button
                      type="button"
                      className="close"
                      onClick={hide}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
